import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "../icon-component.types";

export const IconBulletList: TIconComponent = props => (
    <Icon viewBox="0 0 20 16" fill="none" {...props}>
        <circle cx="2.5" cy="1" r="1" fill="#333333" />
        <circle cx="2.5" cy="8" r="1" fill="#333333" />
        <circle cx="2.5" cy="15" r="1" fill="#333333" />
        <path d="M7.25 0.75H17.75" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.25 8H17.75" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.25 15.25H17.75" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);
